<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout>
      <v-flex xs12 md6 text-xs-center v-for="i in 2" :key="'img'+i">
        <button class="hvr hvr-scale image-button-m2" :class="{'bot-check-vis-cen': vistos[i-1]}" @click="modal=true, text=i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 1/diapositiva-8-'+ i +'.png')" alt="">
        </button>
      </v-flex>
    </v-layout>
    <modal-app v-model="modal" width="800px" :fullscreen="false">
      <div v-if="text == 1">
        <h1 class="modal-title">SEC – Securities and Exchange Commision</h1>
        <p>Es la Comisión de Valores de los Estados Unidos. Esta organización es la encargada de brindar protección de los inversionistas, mantener mercados justos, ordenados y eficientes, y facilitar la formación de capital.</p>
        <p>Ecopetrol debe anualmente presentar ante este ente el reporte 20F que contiene entre otra información las cifras de 
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <span v-on="on" class="tooltip-activator">reservas</span>
            </template>
            <span>Son aquellas cantidades de petróleo y gas que mediante análisis de geociencia e ingeniería pueden ser estimadas con certeza razonable que serán económicamente producibles, a partir de una fecha dada, de yacimientos conocidos, bajo las condiciones económicas, de operación y regulaciones gubernamentales existentes</span>
          </v-tooltip>
          &nbsp;probadas actualizadas a la fecha de emisión del informe, siendo relevante para la Compañía, ya que asegura el flujo de capital de inversión.</p>
        <p>Para consultar la normatividad de obligatorio cumplimiento de la SEC – Securities and Exchange Commision puedes presionar <a href="https://www.sec.gov/divisions/corpfin/ecfrlinks.shtml" target="blank">aquí</a></p>
      </div>
      <div v-if="text == 2">
        <h1 class="modal-title">Agencia Nacional de Hidrocarburos:</h1>
        <p>Es la autoridad en el aprovechamiento óptimo de los recursos de hidrocarburos de Colombia, y es el organismo al cual se debe reportar la información necesaria de reservas, recursos 
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <span v-on="on" class="tooltip-activator">contingentes</span>
            </template>
            <span>Son aquellas cantidades de petróleo recuperable estimadas a una fecha determinada, de acumulaciones conocidas, pero que el desarrollo comercial no está suficiente mente maduro debido a una o más contingencias.</span>
          </v-tooltip> y <v-tooltip top>
            <template v-slot:activator="{on}">
              <span v-on="on" class="tooltip-activator">prospectivos</span>
            </template>
            <span>Son aquellas cantidades de petróleo estimadas a una fecha potencialmente recuperables de acumulaciones no descubiertas por la aplicación de futuros proyectos de desarrollo.</span>
          </v-tooltip>
        </p>
        <p>Entre sus principales lineamientos tenemos:</p>
        <ul>
          <li>Los yacimientos con reservas probadas mayores a un Millón de Barriles de Petróleo Equivalente – MBPE requieren de una auditoría por un tercero independiente.</li>
          <li>Los yacimientos con reservas probadas menores a un Millón de Barriles de Petróleo Equivalente – MBPE debe tener una auditoría interna.</li>
        </ul>
        <p>Ecopetrol reporta cifras tanto a SEC como ante la Agencia Nacional de Hidrocarburos de Colombia – ANH.</p>
        <p>Puedes consultar acuerdos y resoluciones de la normatividad de obligatorio cumplimiento vigente en Colombia, <a href="http://www.anh.gov.co/Paginas/inicio/defaultANH.aspx" target="blank">aquí</a>.</p>
      </div>
    </modal-app>

    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 09'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      text: 1,
      vistos: [false,false],
      dialogos: [
        "¡Excelente!, es momento de ahondar en el marco regulatorio de las reservas y recursos. <span class='instruccion'>Haz clic en los siguientes isologos.</span>" 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
